<script setup lang="ts">
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'

const props = defineProps<{ product: CrystallizeProduct }>()

const card = useProductCard(props.product)
</script>

<template>
  <NuxtLink class="group p-m bg-white rounded-2xl flex gap-l items-center no-underline justify-between transition-all duration-150 ease-out active:scale-100 active:bg-blurple-100 hover:scale-105 hover:bg-blurple-100" :to="card.href">
    <CrystallizeImage :image="card.illustration" class="hidden sm:block min-w-28 w-28 aspect-square" />

    <div class="mr-auto">
      <h5 class="mb-2xs font-semibold" v-text="card.title" />
      <p v-if="card.subtitle" class="mb-s text-base" v-text="card.subtitle" />
      <Price v-if="card.variant" :price="card.variant" interval="yearly" show-suffix />
    </div>

    <Icon :icon="faArrowRight" class="pr-2 group-hover:translate-x-2 transition-transform duration-150 ease-out" />
  </NuxtLink>
</template>
